<script>
import lazyLoadComponent from '@router/lazyload-component'
import { staffComputed } from '@state/helpers'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'

export default {
  page: {
    title: '項目人員管理',
    meta: [{ name: 'description', content: 'Staff List' }],
  },

  components: {
    Layout,
    ListItem: () => lazyLoadComponent(import('./components/ListItem')),
    BaseButtonDialog,
    StaffForm: () => lazyLoadComponent(import('@components/StaffForm')),
  },
  data() {
    return {
      dialogVisible: false,
      dialogItem: {},
      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽
    }
  },
  computed: {
    ...staffComputed,
    dialogTitle() {
      const modeTitleMap = {
        add: '創建人員',
        edit: '編輯人員',
        view: '項目人員',
      }
      return modeTitleMap[this.dialogMode]
    },
  },
  methods: {
    async updateList() {
      await this.$store.dispatch('staff/fetchList')
      this.closeDialog()
    },
    openDialog(mode, itemData) {
      this.dialogVisible = true
      this.dialogMode = mode
      this.$set(this.$data, 'dialogItem', itemData)
    },
    closeDialog() {
      this.dialogVisible = false
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader title="項目人員管理"></BasePageHeader>
    <div :class="[$style['item__list'], $style[`item__list--last-${staffs.length % 5}`]]">
      <ListItem
        v-for="item in staffs"
        :key="item.id"
        :data="item"
        :class="$style.item"
        @view="(itemData) => {
          openDialog('view', itemData) 
        }"
        @edit="(itemData) => {
          openDialog('edit', itemData) 
        }"
      />
    </div>
    <BaseButtonDialog
      :title="dialogTitle"
      :dialog-visible.sync="dialogVisible"
      floating
      @opened="openDialog('add')"
    >
      <div v-if="dialogMode === 'view'">
        <ListItem :data="dialogItem" show-detail @edit="dialogMode = 'edit'" @close="closeDialog" />
      </div>
      <StaffForm v-else :default-value="dialogItem" @store="updateList" @close="closeDialog" />
    </BaseButtonDialog>
  </Layout>
</template>
<style lang="scss" module>
@import '@design';

$column-number: 5;

.item {
  width: calc(100% / #{$column-number} - 15px);
  padding: 20px 10px;
  margin-bottom: 30px;
  background-color: white;
  cursor: pointer;
  transition: $all-transition;
  &:hover {
    @include layer-elevation(8);
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &--last-2:after {
      width: calc(100% / #{$column-number} * 3 - 15px);
      content: '';
    }
    &--last-3:after {
      width: calc(100% / #{$column-number} * 2 - 15px);
      content: '';
    }
    &--last-4:after {
      width: calc(100% / #{$column-number} * 1 - 15px);
      content: '';
    }
  }
}
</style>

